module.exports = __webpack_public_path__ + "img/left_arrow.7aa82347.svg";